<!--arrow_back_ios_new_48dp_FILL1_wght400_GRAD0_opsz48-->
<template>
  <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px">
    <path d="M640-80 240-480l400-400 71 71-329 329 329 329-71 71Z"/>
  </svg>
</template>
